import { summarizeTabs, tabsInLastDays } from './roasts'
import type { Tab } from './types'

export type WeeklyDamageReport = {
  visitCount: number
  totalCents: number
  tipCents: number
  averageTipPercent: number
  topVenue: string
}

/** Rolling 7-day stats for share cards and on-open “damage report” copy. */
export function weeklyDamageReport(tabs: Tab[], now = new Date()): WeeklyDamageReport | null {
  const week = tabsInLastDays(tabs, 7, now)
  if (week.length === 0) return null

  const stats = summarizeTabs(week)
  const venueCounts = new Map<string, number>()
  for (const tab of week) {
    const name = tab.venue.trim() || 'Unnamed watering hole'
    venueCounts.set(name, (venueCounts.get(name) ?? 0) + 1)
  }

  let topVenue = 'Unnamed watering hole'
  let topCount = 0
  for (const [name, count] of venueCounts) {
    if (count > topCount) {
      topCount = count
      topVenue = name
    }
  }

  return {
    visitCount: week.length,
    totalCents: stats.totalCents,
    tipCents: stats.tipCents,
    averageTipPercent: stats.averageTipPercent,
    topVenue,
  }
}
